import { useEffect, useState } from "react";
import Navbar from "../../parts/Navbar/Navbar";
import StepBadge from "../../utils/StepBadge/StepBadge";
import ImportDataStepOne from "./ImportDataStepOne";
import ImportDataStepThree from "./ImportDataStepThree";
import ImportDataStepTwo from "./ImportDataStepTwo";

export default function ImportDataPage() {
  const [step, setStep] = useState(1);
  const [stepTitle, setStepTitle] = useState("Source de données");

  let stepComponent = <ImportDataStepOne navigateToStep={setStep} />;
  if (step === 1) {
    stepComponent = <ImportDataStepOne navigateToStep={setStep} />;
  }
  if (step === 2) {
    stepComponent = <ImportDataStepTwo navigateToStep={setStep} />;
  }
  if (step === 3) {
    stepComponent = <ImportDataStepThree navigateToStep={setStep} />;
  }

  useEffect(() => {
    if (step === 1) {
      setStepTitle("Source de données");
      return;
    }
    if (step === 2) {
      setStepTitle("Mappage des champs");
      return;
    }
    setStepTitle("Importation");
  }, [step]);

  return (
    <div>
      <Navbar pageTitle="Import de données" />

      <div className="ImportDataPage Container">
        <div className="Container-content">
          <div className="Stepper">
            <div className="Stepper-navWrapper">
              <ul className="Stepper-nav">
                <li className="Stepper-header">
                  <StepBadge value={1} active={step === 1} />{" "}
                  <span className={`Stepper-btnLabel ${step === 1 ? " active" : ""}`}>
                    Source de données
                  </span>
                </li>
                <li>
                  <div className="Stepper-divider" />{" "}
                </li>
                <li className="Stepper-header">
                  <StepBadge value={2} active={step === 2} />{" "}
                  <span className={`Stepper-btnLabel ${step === 2 ? " active" : ""}`}>
                    Mappage des champs
                  </span>
                </li>
                <li>
                  <div className="Stepper-divider" />{" "}
                </li>
                <li className="Stepper-header">
                  <StepBadge value={3} active={step === 3} />{" "}
                  <span className={`Stepper-btnLabel ${step === 3 ? " active" : ""}`}>
                    Importation
                  </span>
                </li>
              </ul>

              <h2 className="Stepper-title">{stepTitle}</h2>
            </div>

            <div className="Stepper-body">{stepComponent}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
